import { backendFunction } from './actions-util'

export const _apiAppCreate = (managerUUID, adminUID) =>
	backendFunction('apiAppCreate', {
		managerUUID,
		adminUID,
	})
